import moment from 'moment-jalaali';

/**
 *
 * @param {number} unix time
 * @param {string} format of time
 * @returns {string} convert unix time to date
 *
 */

export function getDate(unix, format = 'dddd / jDD jMMMM / HH:mm') {
  return moment.unix(unix).format(format);
}
